import { alerting } from './alert_modal'

export class FileValidator {
  constructor(file, options) {
    this.file = file
    this.options = options
  }

  async validate() {
    return await this.run()
  }

  run = () => {
    return new Promise((resolve) => {
      // Check file type first
      if (!this.validFileType) {
        this.invalidAlert(`Invalid file type. Only ${this.humanReadableFileType} files are allowed.`)
        resolve(false)
        return
      }

      // Then check file size
      if (!this.validFileSize) {
        this.invalidAlert(`File too large. Maximum size is ${this.options.validSize}MB.`)
        resolve(false)
        return
      }

      // If we get here, file is valid
      resolve(true)
    })
  }

  invalidAlert = (message) => {
    return alerting(
      message || `File was either too large, or wrong type. 
      Contact support if you continue having issues.`,
    )
  }

  get validFile() {
    return this.validFileType && this.validFileSize
  }

  get validFileType() {
    try {
      const mimeType = this.file.type || ''

      // No mimetype - try to guess from extension
      if (!mimeType) {
        return this.validFileExtension
      }

      const baseMimeType = mimeType.replace(/\/.*$/, '')
      const baseValidType = this.options.validType.replace(/\/.*$/, '')
      const validValue = /\/\*$/.test(this.options.validType)

      // For specific MIME types like 'image/jpeg' vs 'image/*'
      if (!validValue) {
        return mimeType === this.options.validType
      }

      return baseMimeType === baseValidType
    }
    catch (e) {
      console.error('Error validating file type:', e)
      return false
    }
  }

  get validFileExtension() {
    try {
      if (!this.file.name) return false

      const extension = this.file.name.split('.').pop().toLowerCase()
      const baseValidType = this.options.validType.replace(/\/.*$/, '')

      // Map common mime base types to extensions
      const extensionMap = {
        image: ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'],
        video: ['mp4', 'webm', 'ogg', 'mov', 'avi'],
        audio: ['mp3', 'wav', 'ogg', 'flac'],
        application: ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'zip'],
      }

      return extensionMap[baseValidType]?.includes(extension) || false
    }
    catch (e) {
      console.error('Error validating file extension:', e)
      return false
    }
  }

  get validFileSize() {
    try {
      return this.file.size < this.options.validSize * 1024 * 1024
    }
    catch (e) {
      console.error('Error validating file size:', e)
      return false
    }
  }

  get humanReadableFileType() {
    const baseType = this.options.validType.replace(/\/.*$/, '')

    // Convert MIME type to readable format
    const readableTypes = {
      image: 'images',
      video: 'videos',
      audio: 'audio files',
      application: 'documents',
      text: 'text files',
    }

    return readableTypes[baseType] || this.options.validType
  }
}
